var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "vs-dropdown",
        {
          staticClass: "cursor-pointer",
          attrs: { "vs-custom-content": "", "vs-trigger-click": "" }
        },
        [
          _c("feather-icon", {
            staticClass: "cursor-pointer mt-1 sm:mr-6 mr-2",
            attrs: { icon: "GlobeIcon" }
          }),
          _vm._v(" "),
          _c(
            "vs-dropdown-menu",
            _vm._l(_vm.languages, function(lang, index) {
              return _c(
                "vs-dropdown-item",
                {
                  key: index,
                  on: {
                    click: function($event) {
                      return _vm.onLocaleChange(lang.code)
                    }
                  }
                },
                [_vm._v("\n        " + _vm._s(lang.name) + "\n      ")]
              )
            }),
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }